// removed by extract-text-webpack-plugin
module.exports = {"shoppingCartRoot":"qempo_ShoppingCart_shoppingCartRoot-2yulMYj","bodyWrap":"qempo_ShoppingCart_bodyWrap-zaJy8p4","titleWrap":"qempo_ShoppingCart_titleWrap-2lD0F8e","contentWrap":"qempo_ShoppingCart_contentWrap-1o0BosO","linkMobile":"qempo_ShoppingCart_linkMobile-21Aceuc","subtitleWrap":"qempo_ShoppingCart_subtitleWrap-2Rqc27i","link":"qempo_ShoppingCart_link-1pkxlk1","cardItemsWraps":"qempo_ShoppingCart_cardItemsWraps-SSmlvMb"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/shopping-cart/components/ShoppingCart/ShoppingCart.scss
// module id = 2278
// module chunks = 0